// eslint-disable-next-line func-names
export default function ({ store, redirect }) {
  const { selectedPlan } = store.state.global;
  if (!selectedPlan) {
    return redirect(`/`);
  }
  return true;
}
